exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dropzone[data-v-de604d6c]{margin-left:auto;margin-right:auto;background-color:#0a0a0a}.vue-dropzone[data-v-de604d6c]{border:3px solid #009e86;color:#dbdbdb;font-size:1.5rem!important}", ""]);

// exports
